module.exports = __webpack_public_path__ + "img/up16.19efc1b2.png";